/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  code3Formatter,
  createDefaultGridModel,
  ROW_DIRTY_CLASS,
} from '@gh/common-internal-shared';
import { NumberTypes, State } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import {
  buildNumberColumn,
  GridModel,
  GridOptionsExt,
  ManualGridDefinitionWithModel,
} from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { isNil } from 'lodash';
import { getJeCostCenterId, JeCostCenter } from '../../../resources/job-estimate-details.model';
import { JeDetailsState, queryJeEditable, queryJeIsCccId } from '../je-details.state';

@Injectable()
export class JeDetailsCcGridDefinition extends ManualGridDefinitionWithModel {

  constructor(private translationService: TranslationService,
              private state: State<JeDetailsState>) {
    super();
  }

  buildGridModel(): GridModel {
    return createDefaultGridModel({
      editable: this.state.select(queryJeEditable),
      getId: getJeCostCenterId,
    });
  }

  buildGridOptions(): GridOptionsExt {
    return {
      rowSelection: { mode: 'singleRow', enableClickSelection: true, checkboxes: false },
      defaultColDef: {
        sortable: false,
      },
      rowClassRules: {
        [ROW_DIRTY_CLASS]: ({ data }: { data: JeCostCenter }) => !isNil(data.dirtyType),
      },
    };
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'code',
      headerName: this.translationService.get('lbl_number'),
      width: 100,
      sort: 'asc',
      valueFormatter: code3Formatter,
    }, {
      field: 'name',
      headerName: this.translationService.get('lbl_description'),
      width: 150,
    }, {
      field: 'cost',
      headerName: this.translationService.get('lbl_order_cost_dollar'),
      width: 120,
      ...buildNumberColumn(NumberTypes.Price),
      valueGetter: ({ data }: { data: JeCostCenter }) =>
        this.state.project(queryJeIsCccId, getJeCostCenterId(data)) ? void 0 : data.cost,
    }];
  }
}
